// extracted by mini-css-extract-plugin
export default {"linkBadgeContainer":"t71ORoqNXWmKSNSx__nV","leftElementContainer":"CRWI1ShdSPpdLj5a3pq5"};